import PropTypes from 'prop-types';
import React from 'react';

import Tree from '../../dataViews/NextTree';
import TreeContext from '../../dataViews/NextTree/TreeContext';
import Empty from '../../utils/Empty';
import Error from '../../utils/Error';
import LoadingMask from '../../utils/LoadingMask';
import Spinner from '../../utils/Spinner';
import { dynamicTreeSearchBodyMapper } from './mappers';

@dynamicTreeSearchBodyMapper
export default class DynamicTreeSearchBodyContent extends React.PureComponent {
  static propTypes = {
    items: PropTypes.array,
    error: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    searchQuery: PropTypes.string.isRequired,
    treeAdapter: PropTypes.object.isRequired,
    treePlugins: PropTypes.array.isRequired,
    treeContext: PropTypes.any,
    rootModels: PropTypes.array,
  };

  static defaultProps = {
    items: [],
    error: null,
    rootModels: null,
    treeContext: null,
  };

  state = {
    showingSearchQuery: null,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { showingSearchQuery } = prevState;
    const { searchQuery, loading, error } = nextProps;

    const searchLoaded = !loading && !error;

    if (showingSearchQuery) {
      if (!searchQuery) {
        return { showingSearchQuery: null };
      } else if (searchQuery !== showingSearchQuery && searchLoaded) {
        return { showingSearchQuery: searchQuery };
      }
    } else {
      if (searchQuery && searchLoaded) {
        return { showingSearchQuery: searchQuery };
      }
    }

    return null;
  }

  get items() {
    return this.props.items;
  }

  getTree = ({ tree, selection, onSelectionChange, filter }) => {
    const { treeAdapter, treePlugins, treeContext, rootModels } = this.props;

    const { showingSearchQuery } = this.state;

    return (
      <Tree
        key={`Search:${tree}`}
        adapter={treeAdapter}
        context={treeContext}
        filter={filter}
        models={rootModels}
        plugins={treePlugins}
        selection={selection}
        tree={`Search:${tree}:${showingSearchQuery}`}
        onSelectionChange={onSelectionChange}
      >
        <Tree.Body models={this.items || []} />
      </Tree>
    );
  };

  render() {
    const { error, loading } = this.props;
    const { showingSearchQuery } = this.state;

    if (error) {
      return <Error error={error} />;
    }

    const items = this.items;
    const hasVisibleData = showingSearchQuery && items && items.length;

    const loadingSomething = Boolean(loading);

    if (!hasVisibleData) {
      if (loadingSomething) {
        return <Spinner inline={false} />;
      }

      return (
        <LoadingMask active={loadingSomething}>
          <Empty />
        </LoadingMask>
      );
    }

    return (
      <LoadingMask active={loadingSomething}>
        <TreeContext.Consumer>{this.getTree}</TreeContext.Consumer>
      </LoadingMask>
    );
  }
}
